/* 
 * Scroll top element
 * 
 * Author: Michael Kohler <michael.kohler@somedia.ch>
 */

// Requires
var $ = require('jquery');
require('devbridge-autocomplete');

// Modul construct
var somModul = {
	
	// Module name
	name: 'solrautocomplete',
	
	// Container
	container: null,
	
	// Init function
	init: function() {
		
		// Init vars
		var componentConfig = this.__getComponentConfig(somModul.name);
		somModul.container = $(componentConfig.selector);

		if(componentConfig.enabled && somModul.container.length != 0 && typeof tx_solr_suggestUrl != 'undefined') {

			// Create plugin config
			var pluginConfig = componentConfig.config;
			$.extend(true, pluginConfig, {
				serviceUrl: tx_solr_suggestUrl,
				transformResult: function(response) {
					return {
						suggestions: $.map(response, function(value, key) {
							return {value: key, data: key};
						})
					};
				},
				onSearchStart: function(params) {
					params.termLowercase = params.termOriginal.toLowerCase();
				},
				onSelect: function() {
					$(this).closest('form').submit();
				},
				triggerSelectOnValidInput: false
			});

			// Init autocomplete
			somModul.container.autocomplete(pluginConfig);

			return true;
		}
	},
};

// Return modul construct - commonJS syntax
module.exports = somModul;


/** WEBPACK FOOTER **
 ** ./src/components/solrautocomplete.js
 **/